(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mp-product')) {
  customElements.define('mp-product', class MpProduct extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.data = JSON.parse(this.querySelector('[data-mp-json]').textContent);
      this.form = this.querySelector('[data-mp-form]');
      this.track = this.querySelector('[data-track]');
      this.initGallery(); this.initLightbox(); this.initVariants(); this.initQty();
      this.initCart(); this.initSticky(); this.initGuide(); this.initDelivery(); this.initShare();
    }
    disconnectedCallback() { this.io?.disconnect(); }
    $(s) { return this.querySelector(s); }
    $$(s) { return [...this.querySelectorAll(s)]; }

    visibleSlides() { return this.$$('[data-slide]:not(.is-hidden)'); }
    isGrid() { return getComputedStyle(this.track).display === 'grid'; }
    currentIndex() {
      const slides = this.visibleSlides(), left = this.track.scrollLeft;
      let best = 0, dist = Infinity;
      slides.forEach((s, i) => { const d = Math.abs(s.offsetLeft - this.track.offsetLeft - left); if (d < dist) { dist = d; best = i; } });
      return best;
    }
    goTo(i, smooth = true) {
      const slides = this.visibleSlides();
      if (!slides.length || this.isGrid()) return;
      i = (i + slides.length) % slides.length;
      this.track.scrollTo({ left: slides[i].offsetLeft - this.track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }
    goToMedia(id) {
      const slide = this.$(`[data-slide][data-media="${id}"]`);
      if (!slide) return;
      if (this.isGrid()) {
        /* En grille : on fait défiler jusqu'à l'image sans modifier l'ordre des médias */
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }
      this.goTo(this.visibleSlides().indexOf(slide));
    }
    syncGallery() {
      const slides = this.visibleSlides(), i = this.currentIndex(), id = slides[i]?.dataset.media;
      const c = this.$('[data-counter]'); if (c) c.textContent = i + 1;
      const t = this.$('[data-total]'); if (t) t.textContent = slides.length;
      this.$$('[data-thumb]').forEach(th => {
        const on = th.dataset.thumb === id;
        th.classList.toggle('is-active', on);
        if (on) {
          const box = th.parentElement, l = th.offsetLeft - box.offsetLeft, r = l + th.offsetWidth;
          if (l < box.scrollLeft) box.scrollTo({ left: l, behavior: 'smooth' });
          else if (r > box.scrollLeft + box.clientWidth) box.scrollTo({ left: r - box.clientWidth, behavior: 'smooth' });
        }
      });
      slides.forEach((s, k) => { if (k !== i) s.querySelector('video')?.pause(); });
    }
    initGallery() {
      if (!this.track) return;
      /* Force le chargement de toutes les images du carrousel : sur Safari, le lazy-loading
         dans un conteneur à défilement horizontal laisse parfois des diapositives vides */
      const loadAll = () => this.$$('[data-slide] img[loading="lazy"], [data-thumb] img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
      if (document.readyState === 'complete') loadAll(); else window.addEventListener('load', loadAll, { once: true });

      let raf;
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => this.syncGallery()); }, { passive: true });
      this.$('[data-prev]')?.addEventListener('click', () => this.goTo(this.currentIndex() - 1));
      this.$('[data-next]')?.addEventListener('click', () => this.goTo(this.currentIndex() + 1));
      this.$$('[data-thumb]').forEach(th => th.addEventListener('click', () => this.goToMedia(th.dataset.thumb)));
      this.track.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.currentIndex() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.currentIndex() + 1); }
      });
      const m = this.data.extra[this.$('[data-vid]').value]?.media;
      if (m) requestAnimationFrame(() => { const sl = this.$(`[data-slide][data-media="${m}"]`); if (sl && !this.isGrid()) this.track.scrollLeft = sl.offsetLeft - this.track.offsetLeft; this.syncGallery(); });
      this.syncGallery();
    }

    initLightbox() {
      const lb = this.$('[data-lightbox]'); if (!lb) return;
      const img = lb.querySelector('[data-lightbox-img]');
      this.addEventListener('click', e => {
        const z = e.target.closest('[data-zoom]'); if (!z) return;
        img.src = z.dataset.zoom; img.alt = z.dataset.alt; lb.showModal();
      });
      lb.addEventListener('click', e => { if (e.target === lb || e.target === img || e.target.closest('[data-close]')) lb.close(); });
    }

    selected() {
      return this.$$('.mp__opt').map(fs => { const sel = fs.querySelector('select'); return sel ? sel.value : fs.querySelector('input:checked')?.value; });
    }
    findVariant(opts) { return this.data.variants.find(v => v.options.every((o, i) => o === opts[i])) || null; }
    markAvailability(opts) {
      this.$$('.mp__opt').forEach((fs, p) => {
        fs.querySelectorAll('input[type=radio]').forEach(inp => {
          const test = [...opts]; test[p] = inp.value;
          const ok = this.data.variants.some(v => v.available && v.options.every((o, i) => o === test[i]));
          inp.nextElementSibling?.classList.toggle('is-unavailable', !ok);
        });
        fs.querySelectorAll('option').forEach(o => {
          const test = [...opts]; test[p] = o.value;
          const ok = this.data.variants.some(v => v.available && v.options.every((x, i) => x === test[i]));
          o.textContent = o.value + (ok ? '' : ' — épuisé');
        });
      });
    }
    initVariants() {
      this.addEventListener('change', e => {
        if (!e.target.matches('[name^="options["]')) return;
        const lbl = e.target.closest('.mp__opt')?.querySelector('[data-opt-val]'); if (lbl) lbl.textContent = e.target.value;
        const opts = this.selected();
        this.markAvailability(opts);
        this.update(this.findVariant(opts));
      });
      if (this.$('.mp__opt')) this.markAvailability(this.selected());
    }
    update(v) {
      const t = this.data.txt;
      const atc = this.$('[data-atc]'), atcLbl = this.$('[data-atc-label]');
      const sBtn = this.$('[data-sticky-atc]'), sLbl = this.$('[data-sticky-label]');
      this.$('[data-error]').hidden = true;
      if (!v) {
        if (atc) { atc.disabled = true; atcLbl.textContent = t.unavailable; }
        if (sBtn) { sBtn.disabled = true; sLbl.textContent = t.unavailable; }
        this.setAvail('out', t.unavailable);
        return;
      }
      const x = this.data.extra[v.id] || {};
      this.$('[data-vid]').value = v.id;
      const sale = v.compare_at_price > v.price;
      const now = this.$('[data-price-now]'); now.textContent = x.price; now.classList.toggle('is-sale', sale);
      const was = this.$('[data-price-was]'); was.hidden = !sale; if (sale) was.lastChild.textContent = x.compare;
      const unit = this.$('[data-unit]'); if (unit) { unit.hidden = !x.unit; unit.textContent = x.unit || ''; }
      const badge = this.$('[data-sale-badge]');
      if (badge) { badge.hidden = !sale; if (sale) badge.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      if (!v.available) this.setAvail('out', 'Épuisé');
      else if (this.data.lowStock && x.tracked && x.qty > 0 && x.qty <= this.data.lowStock) this.setAvail('low', `Plus que ${x.qty} en stock`);
      else this.setAvail('ok', 'En stock');
      if (atc) { atc.disabled = !v.available; atcLbl.textContent = v.available ? t.atc : t.sold; }
      if (sBtn) { sBtn.disabled = !v.available; sLbl.textContent = v.available ? t.sticky : t.sold; }
      const sp = this.$('[data-sticky-price]'); if (sp) sp.textContent = x.price;
      const sv = this.$('[data-sticky-variant]'); if (sv) sv.textContent = v.title + ' · ';
      const q = this.$('[data-qty]');
      if (q && q.type === 'number') {
        q.min = x.min; q.step = x.step; if (x.max) q.max = x.max; else q.removeAttribute('max');
        if (+q.value < x.min) q.value = x.min;
      }
      if (this.dataset.hideVariantMedia === 'true') {
        /* Si la variante n'a pas d'image associée, on n'en masque aucune */
        this.$$('[data-slide][data-vm="true"]').forEach(s => s.classList.toggle('is-hidden', x.media != null && +s.dataset.media !== x.media));
        this.$$('[data-thumb]').forEach(th => { const s = this.$(`[data-slide][data-media="${th.dataset.thumb}"]`); th.classList.toggle('is-hidden', !!s?.classList.contains('is-hidden')); });
      }
      if (x.media) this.goToMedia(x.media); else this.goTo(0, false);
      this.syncGallery();
      const si = this.$('[data-sticky-img]');
      const fm = v.featured_media?.preview_image?.src || v.featured_image?.src;
      if (si && fm) si.src = fm + (fm.includes('?') ? '&' : '?') + 'width=120';
      const url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', url);
    }
    setAvail(state, txt) {
      const el = this.$('[data-avail]'); if (!el) return;
      el.dataset.avail = state; el.hidden = state === 'ok';
      el.querySelector('[data-avail-txt]').textContent = txt;
    }

    initQty() {
      const q = this.$('[data-qty]'); if (!q || q.type !== 'number') return;
      const clamp = n => {
        const min = +q.min || 1, step = +q.step || 1, max = q.max ? +q.max : Infinity;
        n = Math.round((n - min) / step) * step + min;
        return Math.min(Math.max(n, min), max);
      };
      this.$('[data-qty-minus]')?.addEventListener('click', () => { q.value = clamp(+q.value - (+q.step || 1)); });
      this.$('[data-qty-plus]')?.addEventListener('click', () => { q.value = clamp(+q.value + (+q.step || 1)); });
      q.addEventListener('change', () => { q.value = clamp(+q.value || 1); });
    }

    initCart() {
      if (!this.form) return;
      this.form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = this.$('[data-atc]');
        if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
        const err = this.$('[data-error]'); err.hidden = true;
        btn.classList.add('is-loading');
        try {
          const res = await fetch(this.data.addUrl, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(this.form) });
          const json = await res.json();
          if (!res.ok || json.status) throw new Error(json.description || json.message || this.data.txt.error);
          btn.classList.replace('is-loading', 'is-done');
          this.$('[data-live]').textContent = this.data.txt.added;
          setTimeout(() => btn.classList.remove('is-done'), 1600);
          const cart = await fetch(window.Shopify?.routes?.root ? Shopify.routes.root + 'cart.js' : '/cart.js').then(r => r.json()).catch(() => null);
          this.notifyTheme(json, cart);
        } catch (ex) {
          btn.classList.remove('is-loading');
          err.textContent = ex.message || this.data.txt.error; err.hidden = false;
        }
      });
    }
    notifyTheme(item, cart) {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: this.id, data: { source: 'product-form-component', itemCount: cart?.item_count, productId: item?.product_id, didError: false } } }));
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer?.open) { drawer.open(); return; }
      const dawn = document.querySelector('cart-drawer');
      if (dawn?.open) { dawn.classList.remove('is-empty'); dawn.open(); return; }
      if (typeof window.bkOpenCart === 'function') { window.bkOpenCart(); return; }
      if (!document.querySelector('cart-items-component, cart-icon, cart-notification')) location.href = this.data.cartUrl;
    }

    initSticky() {
      const sticky = this.$('[data-sticky]'), cta = this.$('#mp-cta-' + this.dataset.section);
      if (!sticky || !cta) return;
      const toggle = show => { sticky.classList.toggle('is-visible', show); sticky.toggleAttribute('inert', !show); sticky.setAttribute('aria-hidden', String(!show)); };
      this.io = new IntersectionObserver(([en]) => toggle(!en.isIntersecting && en.boundingClientRect.top < 0));
      this.io.observe(cta);
      sticky.querySelector('[data-sticky-atc]')?.addEventListener('click', () => {
        if (this.$('[data-atc]').disabled) { cta.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        this.form.requestSubmit();
      });
    }

    initGuide() {
      const dlg = this.$('[data-guide]'); if (!dlg) return;
      this.$('[data-guide-open]')?.addEventListener('click', () => { dlg.showModal(); document.body.style.overflow = 'hidden'; });
      dlg.addEventListener('click', e => { if (e.target === dlg || e.target.closest('[data-close]')) dlg.close(); });
      dlg.addEventListener('close', () => { document.body.style.overflow = ''; });
    }

    initDelivery() {
      this.$$('[data-delivery]').forEach(el => {
        const min = +el.dataset.min, max = +el.dataset.max, cutoff = +el.dataset.cutoff, now = new Date();
        const addBiz = (d, n) => { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
        let start = new Date(now);
        if (now.getHours() >= cutoff || !(now.getDay() % 6)) start = addBiz(start, 1);
        const fmt = d => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
        el.querySelector('[data-delivery-range]').textContent = `entre le ${fmt(addBiz(start, min))} et le ${fmt(addBiz(start, max))}`;
        const cut = el.querySelector('[data-delivery-cut]');
        if (now.getDay() % 6 && now.getHours() < cutoff) {
          const ms = new Date(now).setHours(cutoff, 0, 0, 0) - now;
          const h = Math.floor(ms / 36e5), m = Math.floor(ms / 6e4) % 60;
          cut.textContent = `Commandez dans les ${h ? h + ' h ' : ''}${m} min pour une expédition aujourd'hui`;
          cut.hidden = false;
        }
      });
    }

    initShare() {
      this.$$('[data-share]').forEach(b => b.addEventListener('click', async () => {
        const url = location.href;
        if (navigator.share) { try { await navigator.share({ title: b.dataset.title, url }); } catch (_) {} return; }
        await navigator.clipboard?.writeText(url);
        const l = b.querySelector('[data-share-label]'), old = l.textContent;
        l.textContent = this.data.txt.copied;
        setTimeout(() => (l.textContent = old), 1800);
      }));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
